
<template>

	<div class="base">
		<b-navbar class="p-0 pb-3 justify-content-between">
			<b-navbar-brand class="p-0">
				<div v-if="has_history" class="d-flex align-items-center" style="gap: .75rem;">

					<b-button class="transparent" @click="go_back">

						<base-icon name="arrow long_left" />

					</b-button>
					<h3>Срок экономической жизни</h3>

				</div>
				<h3 v-else >Срок экономической жизни</h3>
			</b-navbar-brand>

			<b-nav pills class="ml-auto w-50 h-100" style="flex-wrap: unset;">

				<b-form-input class="h-100" v-model="filter" placeholder="Поиск"/>

			</b-nav>
		</b-navbar>

		<div class="btn_group justify-content-between mb-2">
			<div v-if="check_roles([ 'model' ]) && ! $root.not_editable" class="base_bar">
	
				<b-button v-if="selected.length > 0" @click="delete_selected" class="ml-auto" variant="outline-danger" size="sm" v-b-tooltip:hover.bottomright="'Удалить'"><base-icon name="delete" /></b-button>
	
				<div v-else class="base-add">
					<div>Добавить значение:</div>
	
					<div class="base-add_field">
						
						<span>Функциональная группа</span>
						<v-select class="base-add_input" :options="groups" size="sm" v-model="group" clearSearchOnSelect required appendToBody/>
	
					</div>
	
					<div class="base-add_field">
						
						<span>Класс КС</span>
						<reference_values class="base-add_input" v-model="cs" attr_key="attrs.cs" not_original clearable/>
	
					</div>
	
					<b-button v-if="group != null && cs != null" @click="add_one" variant="outline-primary" size="sm" v-b-tooltip:hover.bottomright="'Добавить'"><base-icon name="add" /></b-button>
				</div>

			</div>

			<b-button v-if="is_sort" size="sm" variant="outline-primary" class="nav-button" v-b-tooltip:hover.bottomright="'Сброс сортировки'" v-on:click="clear_sort">
				<base-icon name="sort_cancel" />
			</b-button>
		</div>

		<b-table ref="table" class="m-0" sticky-header :items="rows" :fields="fields" small
			v-on:sort-changed="sort_changed" :sort-by.sync="sort_by" :sort_desc.sync="sort_desc"
		>

			<template v-slot:head(edit)>

				<b-form-checkbox v-on:change="all_edit_change"/>

			</template>

			<template v-slot:cell()="data">

				<div v-if="data.field.editable">
					
					<table_input v-if="data.field.key == 'min_age'"
						title="Приложение №9 МУ П/0336" v-b-tooltip.hover.bottomright
                        :value="data.value" :item="data.item"
                        v-on:change="value => change(data.item, data.field.key, value)"
                        :validation="check_fields.min_age" :readonly="!check_roles([ 'model' ])"
					/>
					<table_input v-else
						:value="data.value" :item="data.item" return_str
						v-on:change="value => change(data.item, data.field.key, value)"
						:validation="check_fields.not_min_age" :readonly="!check_roles([ 'model' ])"
						is_not_required
					/>

				</div>

				<div v-else-if="data.field.key == 'edit'" class="table_div">

					<b-form-checkbox v-model="selected" :value="data.item"/>

				</div>

				<div v-else>{{ data.value }}</div>

			</template>

		</b-table>

	</div>

</template>

<script>

import api from "../../../../api"
import reference_values from "../../../widgets/reference"
import table_input from "../../../widgets/table_input"

export default
{
	props :
	{
		ref_type : String,
	},

	components :
	{
		reference_values,
		table_input
	},

	data()
	{
		return {

			service : "cadastral_expensive",

			id : null,
			data : [],
			groups : [ "01", "02", "03", "04", "05", "06", "07", "08", "09", "10" ],
			selected : [],
			group : null,
			cs : null,

			filter : null,

			is_sort : false,
			sort_by : "group",
			sort_desc : false,

			check_fields :
			{
				min_age :
				{
					check : (value) => api.check_number({ value, gt : 0 }),
					gt_min : 0,
					msg : "Больше 0"
				},
				not_min_age :
				{
					check : (value) => (value === null || value === "" || api.check_number({ value, accuracy : 0, gte : 0 })),
					msg : "Больше или равно 0"
				}
			}
		}
	},

	created() 
	{
		return this.refresh()
	},

	computed :
	{
		has_history()
		{
			return this.$router.history.current.path != this.$router.history._startLocation
			// return window.history.length > 1
		},

		fields()
		{
			const fields = [
				{ key : "group", label : "Функциональная группа", sortable : true },
				{ key : "cs", label : "Класс конструктивной системы", sortable : true },
				{ key : "min_floor", label : "Минимальная этажность", sortable : true, editable : !this.$root.not_editable },
				{ key : "max_floor", label : "Максимальная этажность", sortable : true, editable : !this.$root.not_editable },
				{ key : "min_age", label : "Срок экономической жизни, лет", sortable : true, editable : !this.$root.not_editable },
			]

			if (this.check_roles([ "model" ]) && ! this.$root.not_editable)
			{
				fields.unshift({
					key : "edit",
					label : "",
					tdClass : "cell_checkbox",
					thClass : "cell_checkbox",
				})
			}

			return fields
		},

		rows()
		{
			if (this.filter)
            {
                const exp = new RegExp(this.filter, "i")
                
                return this.data.filter(
					(elem) => 
					{
						var visible = null
						
						for (const field of this.fields)
						{
							const row_value = elem[field.key]
							if (typeof row_value == "string")
							{
								visible = ( row_value.match(exp) ) != null
							}
							else if (typeof row_value == "number")
							{
								visible = ( row_value.toString().match(exp) ) != null
							}
							
							if (visible) break
						}

						return visible
				})
            }
            else
            {
                return this.data
            }
		}
	},

	methods :
	{
		refresh()
		{
			return api.call(this, this.service, "get_min_age", {},	response => { this.data = api.sort_objects_array_by_many_keys(response.data, [ "group", "cs", "min_floor", "max_floor" ]) })
		},

		sort_changed()
		{
			if(! this.is_sort)
			{
				this.is_sort = true
			}
		},

		clear_sort()
		{
			this.is_sort = false
			this.sort_desc = false
			this.sort_by = "group"
		},

		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		change(obj, field, value)
		{
			if (
				this.check_roles([ "model" ])
				&& (
					(field == "min_age" && this.check_fields.min_age.check(value))
					|| (field != "min_age" && this.check_fields.not_min_age.check(value))
				)
			)
			{
				const _value = Number(value)

				if( value === null || value === "")
					obj[field] = null
				else
					obj[field] = _value

				api.call(this, this.service, "set_min_age", { value : obj },
					() =>
					{
						this.refresh()
					},
					() =>
					{
						api.show_notification(this, "Введено некорректное значение")

						this.refresh()
					})
			}
		},

		add_one()
		{
			if (this.check_roles([ "model" ]))
			{
				api.call(this, this.service, "set_min_age", { value : { group : this.group, cs : this.cs, min_age : 100 } }, () => this.refresh())
			}
		},

		delete_selected()
		{
			if (this.check_roles([ "model" ]))
			{
				api.call(this, this.service, "delete_min_age", { values : this.selected },
					() =>
					{
						this.selected = []
						this.refresh()
					})
			}
		},

		all_edit_change(value)
		{
			this.selected = []

			if(value)
				this.data.forEach(elem => this.selected.push(elem))
		},

		go_back()
		{
			api.back.go(this)
		},
	}
}

</script>

<style scoped>
.base
{
	display: flex;
	flex-direction: column;
	height: 100%;
}
.base_bar
{
	flex: 1;
	display: flex;
}
.base-add
{
	display: flex;
	align-items: center;
	height: 2.125rem;
	gap: 1rem;
}
.base-add_field
{
	height: 100%;
	display: flex;
	align-items: center;
	gap: .5rem;
}
.base-add_input
{
	height: 100%;
	width: 8.75rem;
}
.base_frame 
{
	flex: 1;
	overflow: hidden;
}
* >>> .cell_checkbox
{
	padding: .5rem;
	padding-right: .25rem;
}
</style>

<style>
.base_frame > div
{
	display: flex;
	flex-direction: column;
	height: 100%;
}
.base_frame .b-table-sticky-header
{
	flex: 1;
	overflow-y: auto;
}
</style>
